import React from "react";
import './style.css';

export default class DishesListBox extends React.Component {
  render() {
    let cuisines = !Array.isArray(this.props.dishDetail) ? this.props.dishDetail.split(',').length > 3 ? 'Multi cuisine' : this.props.dishDetail :
      this.props.dishDetail.split(',').length > 3 ? 'Multi cuisine' : this.props.dishDetail.join(',').replace(/,/g, ', ');
    return (
      <div data-test-id={"featdishlist-id"}
      className="dish-box-container">
        <div className="dish-image">
          <img
            src={this.props.dishImage}
            alt="dish"
            style={{ opacity: this.props.dish.isDraft ? 0.6 : 1 }}
            onClick={() => this.props.handleClick(this.props.dish)}
          />
        </div>
        <div className="dish-detail">
          <h5 data-test-id={"afeatdishlist-id"}> {this.props.dishHeading}</h5>
          <p data-test-id={"bfeatdishlist-id"} >{cuisines}</p>
          <span data-test-id={"cfeatdishlist-id"} >{this.props.dishChef ? `Offered By: ${this.props.dishChef}` : ''}</span>
        </div>
        {this.props.editChef && (
          <div className="action-icon">
            {this.props.editChef}
          </div>
        )}
      </div>
    )
  }
}
